// needs to refactored heavily... my first React project circa 2016 lol
// and since we're upgrading it to do more, it now needs a store

import Accordion, { AccordionContent, AccordionTrigger } from "@javascript/reactComponents/lds/accordion/Accordion";
import Chip from "@javascript/reactComponents/lds/chips/Chip";
import Heading from "@javascript/reactComponents/lds/typography/Heading";
import FacetSearchCompanyActivity from "./FacetSearchCompanyActivity";
import FacetSearchCompanyWorkingOn from "./FacetSearchCompanyWorkingOn";
import Divider from "../lds/Divider";

/**
 * Renders event categories (e.g. Milestone activity, funding activity, etc.) and
 * also handles clicking a given category or entire section.
 *
 * @component
 * 
 * */
const FacetSections = createReactClass({
  mixins: [
      Reflux.connectFilter(FacetSearchStore, "store", function (data) {
        return data.activities
      }),
  ],
  getInitialState: function(){
    return {
      facet_filters: prep_facet_filters(),
    }
  },
  UNSAFE_componentWillMount:function(){
    const { facet_filters: { activities, affiliations } } = this.state

    FacetSearchCompanyActivityActions.activitiesInitialState(activities.selected);
    FacetSearchAffiliatedWithActions.affiliationsInitialState(affiliations);
  },
  render: function() {
    // Also controls which categories are highlighted,
    // so it needs to update on every render.
    const facet_sections = prep_facet_sections();

    return (
      <div>
        { _.map(facet_sections, (facet_data) => <FacetSection key={facet_data.id} facet_data={facet_data} />) }
      </div>
    );
  }
});

var FacetSection = createReactClass({
  getInitialState: function(){
    return {
      open: this.props.facet_data.id !== 'affiliated_with'
    }
  },
  toggle: function (){
    this.setState({ open: !this.state.open });
  },
  render: function(){
    const {open} = this.state
    var id = this.props.facet_data.id;
    let div_classes = ['facet_section_label', 'foldable_label'];

    // TODO: What is this feature flag supposed to accomplish??
    if(_.contains(Zymewire.user.feature_tags, "cmo_concepts_and_associations")) {
      div_classes.push('facet_section_label_CMO', 'foldable_label_CMO');
    }

    const iconForId = {
      activity_type: "activity",
      affiliated_with: "microscope"
    }
    
    const trailingAction = (
      <>
        <div className="flex-grow-1" />
        <Chip
          label=""
          selected={open}
          size="small"
          leadingIcon={`chevron-${open ? "up" : "down"}-centered`}
          variant={open ? "primary" : "secondary"}
        />
      </>
    );
    return (
      <>
        <Divider className="facet-search-section-divider" size="small" variant="secondary" />

        <Accordion
          open={this.state.open}
          className={`filter_category ${id}_filter_category`}
        >
          <AccordionTrigger onClick={this.toggle} className="cursor-pointer">
            <Heading
              className={id + "_div"}
              size="h3"
              leadingIcon={iconForId[id]}
              trailingAction={trailingAction}
            >
              {this.props.facet_data.name}
            </Heading>
          </AccordionTrigger>
          <AccordionContent gap="var(--filter-category-space-gap)">
            <FacetContent content={this.props.facet_data.content} />
          </AccordionContent>
        </Accordion>
      </>
    );
  }
});

var FacetContent = createReactClass({
  render: function() {
    let div_classes = ["flex-col"];
    if(_.contains(Zymewire.user.feature_tags, "cmo_concepts_and_associations")) {
      div_classes.push('facet_section_foldable_content_CMO');
    }

    var facet_elements = _.map(this.props.content, function(element, index){
      if(element.type === 'activity'){
        return <FacetSearchCompanyActivity key={element.id} data={element} />
      }
      else if(element.type === 'affiliation'){
        return <FacetSearchCompanyWorkingOn key={element.id} data={element} />
      }
      else {
        // houstonwehaveaquestionandthatquestionisWTF
        console.log('facet what?')
        return null
      }
    }.bind(this));
    return (
      <div className={div_classes.join(' ')} style={{ gap: "var(--filter-category-space-gap)" }}>
        {facet_elements}
      </div>
    );
  }
});

window.FacetSections = FacetSections;
export default FacetSections;
